import create_discussion_methods_part1 from './create_discussion_methods_part1';
import create_discussion_methods_part2 from './create_discussion_methods_part2';

export default {
  ...create_discussion_methods_part1,
  ...create_discussion_methods_part2
};

